import { BrowserRouter } from 'react-router-dom'

import Router from './routes'

import './index.css'

const App = () => (
  <BrowserRouter>
    <Router />
  </BrowserRouter>
)

export default App
